var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.5002C11.5899 14.5002 14.5 11.5901 14.5 8.00024C14.5 4.41039 11.5899 1.50024 8 1.50024C4.41015 1.50024 1.5 4.41039 1.5 8.00024C1.5 11.5901 4.41015 14.5002 8 14.5002ZM9.49997 5.04034C9.49997 5.83563 8.85526 6.48034 8.05997 6.48034C7.26468 6.48034 6.61997 5.83563 6.61997 5.04034C6.61997 4.24505 7.26468 3.60034 8.05997 3.60034C8.85526 3.60034 9.49997 4.24505 9.49997 5.04034ZM5.9 9.25747V7.54319H8.64253H9.49997V12.4035H7.78568V9.25747H5.9Z",
    fill: "#95989A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.204cf0ce07d9bd10dfe909422fcc1d6f.svg";
export { ForwardRef as ReactComponent };